import { SvgIcon, SvgIconProps } from "@mui/joy";
import { forwardRef } from "react";

const Challenge = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3431 1.82617C13.9052 0.264093 16.4383 0.264129 18.0004 1.82617L18.9301 2.75586C19.6801 3.50594 20.6974 3.92766 21.7582 3.92773H23.0717C25.2807 3.9279 27.0717 5.7187 27.0717 7.92773V9.24023C27.0717 10.3008 27.4927 11.3183 28.2426 12.0684L29.1732 13C30.7348 14.5621 30.735 17.0943 29.1732 18.6562L28.2426 19.5859C27.4926 20.336 27.0718 21.3534 27.0717 22.4141V23.7275C27.0716 25.9365 25.2806 27.7274 23.0717 27.7275H21.7582C20.6974 27.7276 19.6801 28.1493 18.9301 28.8994L18.0004 29.8291C16.4383 31.3909 13.9052 31.3911 12.3431 29.8291L11.4135 28.8984C10.6633 28.1486 9.64599 27.7275 8.58533 27.7275H7.27185C5.06277 27.7275 3.27195 25.9366 3.27185 23.7275V22.4131C3.27174 21.3524 2.85002 20.335 2.09998 19.585L1.17126 18.6562C-0.390574 17.0944 -0.391096 14.5622 1.17029 13L2.09998 12.0693C2.8499 11.3192 3.27185 10.3019 3.27185 9.24121V7.92773C3.27185 5.7186 5.06271 3.92773 7.27185 3.92773H8.58533C9.64613 3.92773 10.6633 3.50593 11.4135 2.75586L12.3431 1.82617ZM13.2094 17.5361L9.64294 13.9482L7.5365 16.0547L13.1674 21.6855L22.8451 12.0088L20.7806 9.96484L13.2094 17.5361Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
});

Challenge.displayName = "Challenge";

export default Challenge;
